<template>
  <el-row id="app" :class="{'html_gary': html_gary}">
    <Header />
    <router-view class="tabs-fixed-top" />
    <index_bottom />
  </el-row>
</template>

<script>
import Header from '@/components/Header.vue'
import { showHtmlGray } from '@/api'

export default {
  name: 'App',
  components: { Header },
  data() {
    return {
      html_gary: false
    }
  },
  created() {
    // 是否设置灰色滤镜，一般公祭日之类在后台设置
    showHtmlGray()
      .then(rep => {
        if (rep) {
          const b = rep.html_gray
          if (b && (b + '') === '1') {
            this.html_gary = true
            return
          }
        }
        this.html_gary = false
      })
  }
}
</script>

<style scoped>
.html_gary {
  -webkit-filter: grayscale(100%);
  filter:progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
}
</style>
